module.exports = __webpack_public_path__ + "img/pro_ten_6.9b2974dc.jpg";